{
  "customer-selection-form": {
    "buttons": {
      "close": "Đóng",
      "create_new_customer_profile": "Tạo mới",
      "select": "Chọn",
      "selected": "Đã chọn"
    },
    "text": {
      "search_field_label": "Tìm kiếm theo số điện thoại, email hoặc tên",
      "title": "Lựa chọn khách hàng"
    }
  }
}
